export default __webpack_public_path__ + "static/media/hacktoberfestIcon.f42e3b1f.svg";